module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-region/home-main-modal-region.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-region/home-main-modal-region.component.sass
// module chunks = main